import * as React from "react";
import {LinearProgress, CircularProgress} from "@octopusdeploy/design-system-components";
import styles = require("./style.less");

interface BusyIndicatorProps {
    show: boolean;
    inline?: boolean;
}

const BusyIndicator: React.FC<BusyIndicatorProps> = props => {
    if (props.inline) {
        return props.show &&
            <span className={styles.circularBusyIndicator}>
                <CircularProgress size="small" />
            </span>;
    } else {
        return props.show
            ? <div className={styles.busyIndicator}>
                <LinearProgress show={true} variant="indeterminate" />
            </div>
            : <div className={styles.busyIndicatorHiddenSpacer} />;
    }
};

BusyIndicator.displayName = "BusyIndicator";

export default BusyIndicator;
